import React, { useEffect } from 'react';

import { META_TYPE, META_NUM_OPERATOR, META_STR_OPERATOR } from '@vlabs/api-bindings/src/constants';
import { DeleteIcon } from '@vlabs/icons';
import { Control, Divider } from '@vlabs/uikit';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import validate from '@vlabs/shared/validators';

import st from '../../shared.module.sass';

export function MetaFilter({ i, remove }) {
  const { t } = useTranslation();
  const {
    register,
    formState: { errors },
    control,
    watch,
    setValue,
  } = useFormContext();
  const type = useWatch({ name: `meta.${i}.type` })?.value;

  useEffect(() => {
    const sub = watch((_, { name }) => {
      if (name === `meta.${i}.type`) {
        setValue(`meta.${i}.operator`, undefined);
      }
    });

    return () => sub.unsubscribe();
  }, [watch, setValue, i]);

  return (
    <React.Fragment>
      <div className={st.flex}>
        <span className="Subtitle-1">{t('events:meta_filter')}</span>

        {/* {i !== 0 && ( */}
        <Control.IconButton
          data-testid="meta.deleteButton"
          icon={<DeleteIcon />}
          kind="negative"
          onClick={() => remove(i)}
          title={t('btn.delete')}
          variant="filled"
        />
        {/* )} */}
      </div>

      <Control.Input
        {...register(`meta.${i}.key`, {
          required: validate.required(),
          validate: validate.metaKey(),
        })}
        errors={errors}
        isClearable
        label={t('events:key')}
        placeholder={t('enter')}
      />
      <Divider small />

      <Control.Input
        {...register(`meta.${i}.value`, {
          required: validate.required(),
          validate: validate.metaValue(type),
        })}
        errors={errors}
        isClearable
        label={t('events:value')}
        placeholder={t('enter')}
      />
      <Divider small />

      <Control.Select
        control={control}
        errors={errors}
        isClearable
        label={t('events:type')}
        name={`meta.${i}.type`}
        options={META_TYPE.raw}
        rules={{ required: validate.required() }}
      />
      <Divider small />

      <Control.Select
        control={control}
        disabled={!watch(`meta.${i}.type`)}
        errors={errors}
        isClearable
        label={t('events:operator')}
        name={`meta.${i}.operator`}
        options={(watch(`meta.${i}.type`)?.value === 'string')
          ? META_STR_OPERATOR.raw : META_NUM_OPERATOR.raw}
        rules={{ required: validate.required() }}
      />
      <Divider small />
    </React.Fragment>
  );
}
